
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface CoverImageRowProps {
  coverImage: string;
  onCoverImageChange: (coverImage: string) => void;
}

const CoverImageRow: React.FC<CoverImageRowProps> = ({
  coverImage,
  onCoverImageChange
}) => {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:gap-4">
      <Label htmlFor="coverImage" className="lg:w-32 lg:flex-shrink-0 text-sm font-medium">
        Cover Image URL
      </Label>
      <Input
        id="coverImage"
        placeholder="https://example.com/image.jpg"
        value={coverImage}
        onChange={(e) => onCoverImageChange(e.target.value)}
        className="lg:flex-1"
      />
    </div>
  );
};

export default CoverImageRow;
